<mat-spinner *ngIf="submitting" color="primary" diameter="75"></mat-spinner>
<div *ngIf="!submitting">
  <p>
    Als u op 'Voer uit' klikt, zal de procedure uitgevoerd worden die gepland
    staat elke dag om 2u 's nachts. Dit houdt in dat alle opdrachten die niet
    zijn afgeklikt door de installateur vanaf gisteren tot en met hoogstens een
    week geleden zullen verschuiven naar de lijst 'Niet uitgevoerd'. Klik op
    'Voer uit' als u zeker bent dat u de procedure wil laten lopen.
  </p>

  <div class="d-flex pull-right">
    <button mat-flat-button (click)="close()">Annuleer</button>
    <button
      class="button left-space"
      mat-flat-button
      (click)="doUnassignExpiredSubProjects()"
    >
      Voer uit
    </button>
  </div>
</div>
